import { useState, useEffect, useCallback } from "react";
import services from "commons/apis/index";

const useGetBookingWonPrize = (
    projectId,
    bookingId,
    timeWonPrize,
    stt,
    count = 10,
    page = 0
) => {
    const [data, setData] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const fetchBookings = useCallback(async () => {
        if (!projectId) {
            setData([]);
            return;
        }

        setLoading(true);
        try {
            const rawParams = {
                ProjectIdFilter: projectId,
                bookingIdFilter: bookingId,
                STTFilter: stt,
                TimeWonPrizeFrom: timeWonPrize?.from,
                TimeWonPrizeTo: timeWonPrize?.to,
                maxResultCount: count,
                skipCount: page * count,
            };

            const params = Object.fromEntries(
                Object.entries(rawParams).filter(
                    ([, value]) => value !== undefined && value !== null && value !== ""
                )
            );

            const { result } = await services.getBookingWonPrizeForWebsite(params);
            setData(result.items || []);
            setTotalItemCount(result.totalCount || 0);
            setTotalPage(Math.ceil((result.totalCount || 0) / count));
        } catch (error) {
            console.error("Failed to fetch booking won prizes:", error);
        } finally {
            setLoading(false);
        }
    }, [
        projectId,
        bookingId,
        timeWonPrize?.from,
        timeWonPrize?.to,
        stt,
        count,
        page,
    ]);

    useEffect(() => {
        fetchBookings();
    }, [fetchBookings]);

    return {
        data,
        totalPage,
        totalItemCount,
        loading,
        refetch: fetchBookings,
    };
};

export default useGetBookingWonPrize;
